import { render, staticRenderFns } from "./shopDetailImages.vue?vue&type=template&id=62157135&scoped=true&"
import script from "./shopDetailImages.vue?vue&type=script&lang=js&"
export * from "./shopDetailImages.vue?vue&type=script&lang=js&"
import style0 from "./shopDetailImages.vue?vue&type=style&index=0&id=62157135&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62157135",
  null
  
)

export default component.exports